import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ClassifyTemplate(
    $customerId: ID!
    $allInstructionsData: JSON!
    $toolList: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    classifyTemplate(
      customerId: $customerId
      allInstructionsData: $allInstructionsData
      toolList: $toolList
      urlExtractions: $urlExtractions
    )
  }
`;

export const classifyTemplate = async ({
  customerId,
  allInstructionsData,
  toolList,
  urlExtractions,
}) => {
  const variables = {
    customerId,
    allInstructionsData: JSON.stringify(allInstructionsData),
    toolList: JSON.stringify(toolList),
    urlExtractions,
  };

  let result;

  try {
    result = await executeGqlMutation({
      mutation: MUTATION,
      variables,
      options: {
        traceAcRequests: true,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[classifyTemplate] GraphQL error (caught)', error);
    return null;
  }
  if (result?.errors?.length) {
    // eslint-disable-next-line no-console
    console.error('[classifyTemplate] GraphQL errors in result', result.errors);
    return null;
  }
  return getSingleProp(result.data);
};
